/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ChargingSuccessRateResponse
 */
export interface ChargingSuccessRateResponse {
    /**
     * The charging success rate as a percentage (0-100) for the specified period
     * @type {number}
     * @memberof ChargingSuccessRateResponse
     */
    chargingSuccessRate?: number;
    /**
     * Number of successful charging sessions in the period
     * @type {number}
     * @memberof ChargingSuccessRateResponse
     */
    successfulSessions?: number;
    /**
     * Number of failed charging sessions in the period
     * @type {number}
     * @memberof ChargingSuccessRateResponse
     */
    failedSessions?: number;
    /**
     * Total number of charging sessions (successful + failed) in the period
     * @type {number}
     * @memberof ChargingSuccessRateResponse
     */
    totalSessions?: number;
    /**
     * Percentage change compared to the previous period of the same duration. Positive values indicate improvement.
     * @type {number}
     * @memberof ChargingSuccessRateResponse
     */
    percentageChange?: number;
    /**
     * Start of the calculation period
     * @type {Date}
     * @memberof ChargingSuccessRateResponse
     */
    periodStart?: Date;
    /**
     * End of the calculation period
     * @type {Date}
     * @memberof ChargingSuccessRateResponse
     */
    periodEnd?: Date;
}

/**
 * Check if a given object implements the ChargingSuccessRateResponse interface.
 */
export function instanceOfChargingSuccessRateResponse(
    value: object,
): value is ChargingSuccessRateResponse {
    return true;
}

export function ChargingSuccessRateResponseFromJSON(
    json: any,
): ChargingSuccessRateResponse {
    return ChargingSuccessRateResponseFromJSONTyped(json, false);
}

export function ChargingSuccessRateResponseFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ChargingSuccessRateResponse {
    if (json == null) {
        return json;
    }
    return {
        chargingSuccessRate:
            json["chargingSuccessRate"] == null
                ? undefined
                : json["chargingSuccessRate"],
        successfulSessions:
            json["successfulSessions"] == null
                ? undefined
                : json["successfulSessions"],
        failedSessions:
            json["failedSessions"] == null ? undefined : json["failedSessions"],
        totalSessions:
            json["totalSessions"] == null ? undefined : json["totalSessions"],
        percentageChange:
            json["percentageChange"] == null
                ? undefined
                : json["percentageChange"],
        periodStart:
            json["periodStart"] == null
                ? undefined
                : new Date(json["periodStart"]),
        periodEnd:
            json["periodEnd"] == null ? undefined : new Date(json["periodEnd"]),
    };
}

export function ChargingSuccessRateResponseToJSON(
    value?: ChargingSuccessRateResponse | null,
): any {
    if (value == null) {
        return value;
    }
    return {
        chargingSuccessRate: value["chargingSuccessRate"],
        successfulSessions: value["successfulSessions"],
        failedSessions: value["failedSessions"],
        totalSessions: value["totalSessions"],
        percentageChange: value["percentageChange"],
        periodStart:
            value["periodStart"] == null
                ? undefined
                : value["periodStart"].toISOString(),
        periodEnd:
            value["periodEnd"] == null
                ? undefined
                : value["periodEnd"].toISOString(),
    };
}
